/**
 * CSV 데이터 export 유틸리티 함수
 */
import dayjs from 'dayjs';

/**
 * 값을 CSV 셀 형식으로 변환
 * - 쉼표, 개행, 따옴표가 포함된 경우 따옴표로 감싸기
 * - 내부 따옴표는 이스케이프 처리
 */
const escapeCsvCell = (value: unknown): string => {
  if (value === null || value === undefined) {
    return '';
  }

  const stringValue = String(value);

  if (stringValue.includes(',') || stringValue.includes('\n') || stringValue.includes('"')) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }

  return stringValue;
};

/**
 * 2D 배열 데이터를 CSV 문자열로 변환
 */
export const convertToCsv = (headers: string[], rows: Array<Array<unknown>>): string => {
  const csvHeaders = headers.map(escapeCsvCell).join(',');
  const csvRows = rows.map((row) => row.map(escapeCsvCell).join(',')).join('\n');

  return `${csvHeaders}\n${csvRows}`;
};

/**
 * CSV 문자열을 Blob으로 변환하여 다운로드
 */
export const downloadCsv = (csvContent: string, filename: string): void => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');

  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
};

/**
 * 샘플 데이터를 CSV 파일로 export
 */
export const exportSampleDataToCsv = (columns: string[], rows: Array<Array<unknown>>, tableName: string): void => {
  const csvContent = convertToCsv(columns, rows);
  const timestamp = dayjs().format('YYYY-MM-DD');
  const filename = `${tableName}_sample_data_${timestamp}.csv`;

  downloadCsv(csvContent, filename);
};
